import { render, staticRenderFns } from "./OptionRequest.vue?vue&type=template&id=315632dc&"
import script from "./OptionRequest.vue?vue&type=script&lang=js&"
export * from "./OptionRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports